import type { AddressFieldConfig, AddressInputId } from '../types/address.types';

export const ADDRESS_INPUT_IDS = [
  'address1',
  'address2',
  'city',
  'state',
  'zipCode',
  'country',
] as const satisfies readonly AddressInputId[];

export const ADDRESS_FIELDS = {
  address1: {
    label: 'Address 1',
    placeholder: 'Your Address',
    controlName: 'address1',
    inputId: 'address1',
    fragmentName: 'address1',
    inputType: 'text',
  },
  address2: {
    label: 'Address 2',
    placeholder: 'apt, suite, etc. (optional)',
    controlName: 'address2',
    inputId: 'address2',
    fragmentName: 'address2',
    inputType: 'text',
  },
  city: {
    label: 'City',
    placeholder: 'Your City',
    controlName: 'city',
    inputId: 'city',
    fragmentName: 'city',
    inputType: 'text',
  },
  state: {
    label: 'State',
    placeholder: 'Select',
    controlName: 'state',
    inputId: 'state',
    fragmentName: 'state',
    inputType: 'select',
  },
  zipCode: {
    label: 'Zip Code',
    placeholder: 'Your Zip Code',
    controlName: 'zipCode',
    inputId: 'zipCode',
    fragmentName: 'zip-code',
    inputType: 'text',
  },
  country: {
    label: 'Country',
    placeholder: 'Select',
    controlName: 'country',
    inputId: 'country',
    fragmentName: 'country',
    inputType: 'select',
  },
} as const satisfies Record<AddressInputId, AddressFieldConfig>;
